// extracted by mini-css-extract-plugin
export default {"wrap":"Auth_wrap__Vsai7"};